import React from "react";
import { mergeStyles } from '@fluentui/merge-styles';
import { selectorCardStyle } from "./selectorCardStyles";

const switchCard = mergeStyles(selectorCardStyle, {
    selectors: {
        'input': {
            position: 'absolute',
            width: 0,
            height: 0,
            opacity: 0,
            margin: 0,
        },
        // Track
        '.switch-span': {
            display: 'inline-block',
            position: 'relative',
            flexShrink: 0,
            margin: '2px 0',
            height: 'var(--druid-switch-height)',
            width: 'var(--druid-switch-width)',
            borderRadius: 'var(--druid-switch-border-radius)',
        },
        '.switch-span::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            borderRadius: 'var(--druid-switch-border-radius)',
            backgroundColor: 'var(--druid-selector-track-bg)',
            transition: 'background-color 150ms ease-in',
        },
        // Thumb
        '.switch-span::after': {
            content: '""',
            position: 'absolute',
            top: 'var(--druid-switch-thumb-offset)',
            left: 'var(--druid-switch-thumb-offset)',
            height: 'var(--druid-switch-thumb-size)',
            width: 'var(--druid-switch-thumb-size)',
            borderRadius: '50%',
            backgroundColor: 'var(--druid-selector-mark-color)',
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.15)',
            transition: 'transform 150ms ease-in',
        },
        '&:hover .switch-span::before': {
            backgroundColor: 'var(--druid-selector-hover-bg)',
        },
        '&:hover .switch-span::after': {
            height: 'var(--druid-switch-thumb-size-hover)',
            width: 'var(--druid-switch-thumb-size-hover)',
            top: 'var(--druid-switch-thumb-offset-hover)',
            left: 'var(--druid-switch-thumb-offset-hover)',
        },
        // Checked
        'input:checked + .switch-span::before': {
            backgroundColor: 'var(--druid-selector-selected-bg)',
        },
        'input:checked + .switch-span::after': {
            transform: 'translateX(calc(var(--druid-switch-width) - var(--druid-switch-thumb-size) - (var(--druid-switch-thumb-offset) * 2)))',
        },
        '&:hover input:checked + .switch-span::before': {
            backgroundColor: 'var(--druid-selector-selected-hover-bg)',
        },
        'input:checked + .switch-span:hover::after, &:hover input:checked + .switch-span::after': {
            height: 'var(--druid-switch-thumb-size-hover)',
            width: 'var(--druid-switch-thumb-size-hover)',
        },
        // Keyboard focus ring
        'input:focus-visible + .switch-span': {
            outline: '2px solid var(--druid-selector-focus-outline-color)',
            outlineOffset: '2px',
        },
    },
});


interface SwitchSelectorProps {
    id: string;
    value: any;
    label: string;
    highlightClassName?: string;
    onChange: (styleElementName: string, value: any) => void;
}

export const SwitchSelector = (props: SwitchSelectorProps) => {
    const { id, value, label, highlightClassName, onChange } = props;
    return (
        <label className={switchCard}>
            <input type="checkbox" checked={!!value} onChange={e => onChange(id, e.target.checked)} />
            <span className="switch-span" />
            <span className={`${highlightClassName ? ` ${highlightClassName}` : ''}`}><strong>{label} </strong>({id})</span>
        </label>
    );
}
